import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export interface ForecastingPoFlagState {
  readonly pending: boolean;
  readonly enabled: boolean;
}

export function useForecastingPoFlag(): ForecastingPoFlagState {
  const user = useContext(UserContext);
  const team = useRequiredContext(TeamContext);
  const platformRpcClient = useRequiredContext(
    RedoPlatformAuthRpcClientContext,
  );

  const isRedoEmail = isRedoEmailAddress(user?.email);

  const query = useQuery({
    queryKey: ["featureFlag", FeatureFlagKey.FORECASTING_PO, String(team._id)],
    queryFn: async () => {
      const response = await platformRpcClient.getFeatureFlag({
        flagKey: FeatureFlagKey.FORECASTING_PO,
      });
      return response.enabled;
    },
    enabled: !isRedoEmail,
    staleTime: Infinity,
  });

  return {
    pending: !isRedoEmail && query.isPending,
    enabled: isRedoEmail || (query.data ?? false),
  };
}
